import React from 'react'
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/home/Home'
import Login from '../pages/login/Login'
import Users from '../pages/users/Users'
import Artists from '../pages/artists/Artists'
import Songs from '../pages/songs/Songs'
import Villages from '../pages/villages/Villages'

import Votes from '../pages/votes/Votes'
import QrCode from '../pages/codeqr/QrCode';

const Router = () => {
  return (

 
    <Routes>
      {/* <Route path='/' element={< Main />} /> */}
      <Route path='/' element={< Home />} />
      <Route path='/login' element={< Login />} />   
      <Route path='/users' element={< Users />} />   
      <Route path='/artists' element={< Artists />} />   
      <Route path='/songs' element={< Songs />} />   
      <Route path='/villages' element={< Villages />} />   
      <Route path='/votes' element={< Votes />} />   
      <Route path='/codeqr' element={< QrCode />} />   
    </Routes>

  ) 
}


export default Router;
